import { render, staticRenderFns } from "./MallAddForm.vue?vue&type=template&id=79bb1beb&scoped=true&"
import script from "./MallAddForm.vue?vue&type=script&lang=ts&"
export * from "./MallAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./MallAddForm.vue?vue&type=style&index=0&id=79bb1beb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb1beb",
  null
  
)

export default component.exports